import React, { useContext } from 'react';
import AssessmentsBar from './AssessmentsBar';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { AccountContext } from '../../../../components/AccountContext';
import useSubscriptionExpiredRestrictions from '../../../../hooks/useSubscriptionExpiredRestrictions';

const AssessmentsAndRespondentsCount = ({ respondentsCount, assessmentsCount, assessmentsByStatus }) => {
  const currentAccount = useContext(AccountContext);
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  const respondentListURL = `/accounts/${currentAccount}/respondents`;
  const newResUrl = `/accounts/${currentAccount}/respondents/new`;

  if (respondentsCount) {
    return (
      <div className="panel-body">
        <div data-t="candidates">
          <p className="text-muted">
            <FormattedMessage id="assessment.plural" defaultMessage="Assessments">
              {(text) => <span>{text}: </span>}
            </FormattedMessage>
            {assessmentsCount}
          </p>
          <div className="center-block text-center">
            <AssessmentsBar assessmentsByStatus={assessmentsByStatus} />
            <p>
              <Link to={respondentListURL} className="btn btn-primary">
                <FormattedMessage id="candidate.view" defaultMessage="View Respondents">
                  {(text) => <span>{text}</span>}
                </FormattedMessage>
              </Link>
            </p>
          </div>
        </div>
      </div>
    );
  } else {
    if (!subscriptionIsExpired) {
      return (
        <div className="panel-body">
          <div className="center-block text-center" data-t="candidates">
            <FormattedMessage id="candidate.empty" defaultMessage="No Respondents">
              {(text) => <p className="text-muted">{text}</p>}
            </FormattedMessage>
            <Link to={newResUrl} className="btn btn-primary">
              <FormattedMessage id="candidate.add" defaultMessage="New Respondent">
                {(text) => <span>{text}</span>}
              </FormattedMessage>
            </Link>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
};

export default AssessmentsAndRespondentsCount;
